var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F90",
    d: "M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0m0 .923a5.077 5.077 0 1 0 0 10.154A5.077 5.077 0 0 0 6 .923m0 6.923a.693.693 0 1 1-.002 1.385A.693.693 0 0 1 6 7.846M6 2.77a.46.46 0 0 1 .462.46v3.232a.463.463 0 0 1-.924 0V3.23A.46.46 0 0 1 6 2.77"
  })));
};
export default SvgWarning;